import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useHistory } from '@confluence/route-manager/entry-points/RouteState.ts';

import type { GetFeatureCodesResponse } from '../entry-points/FeatureCodeModel.ts';
import { getFeatureCodes } from '../entry-points/featureCodes.ts';
import { FEATURE_CODES_QUERY_PARAM } from '../entry-points/FeatureCodeModel.ts';

// eslint-disable-next-line import/no-cycle
import { hideFeatureCodesQueryParam } from './featureCodes.ts';

/**
 * Hook to extract feature codes from the URL and hide them from the URL
 *
 * @param queryParams - The query parameters from the URL
 * @returns The feature codes extracted from the URL
 */
export const useFeatureCodesInURL = (): GetFeatureCodesResponse => {
	const history = useHistory();
	const location = useLocation();

	const queryParams = location?.search;
	const queryParamsFeatureCodes = getFeatureCodes(new URLSearchParams(queryParams));

	const [featureCodes, setFeatureCodes] =
		useState<GetFeatureCodesResponse>(queryParamsFeatureCodes);

	useEffect(() => {
		if (queryParams && queryParams.includes(FEATURE_CODES_QUERY_PARAM)) {
			setFeatureCodes(queryParamsFeatureCodes);
			hideFeatureCodesQueryParam(history, location);
		}
	}, [history, location, queryParams, queryParamsFeatureCodes]);

	return featureCodes;
};
